<script>
  import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'permissionMap'
    ])
  },
  methods: {
    // general
    canCreate(key) {
      var pMap = new Map(JSON.parse(this.permissionMap))
      return (pMap.get(key) & 1) === 1
    },
    canRead(key) {
      var pMap = new Map(JSON.parse(this.permissionMap))
      return (pMap.get(key) & 2) === 2
    },
    canUpdate(key) {
      var pMap = new Map(JSON.parse(this.permissionMap))
      return (pMap.get(key) & 4) === 4
    },
    canDelete(key) {
      var pMap = new Map(JSON.parse(this.permissionMap))
      return (pMap.get(key) & 8) === 8
    },
    // key = 'campaign' only
    canModerate(key) {
      var pMap = new Map(JSON.parse(this.permissionMap))
      return (pMap.get(key) & 16) === 16
    },
    canUpdateAfterModerating(key) {
      var pMap = new Map(JSON.parse(this.permissionMap))
      return (pMap.get(key) & 32) === 32
    },
    canAccessAdditionalParameters(key) {
      var pMap = new Map(JSON.parse(this.permissionMap))
      return (pMap.get(key) & 64) === 64
    },
    // key = 'user' only
    canSelectUser(key) {
      var pMap = new Map(JSON.parse(this.permissionMap))
      return (pMap.get(key) & 16) === 16
    },
    canUpdateUserTypeAndState(key) {
      var pMap = new Map(JSON.parse(this.permissionMap))
      return (pMap.get(key) & 32) === 32
    },
    canUpdateUserPayment(key) {
      var pMap = new Map(JSON.parse(this.permissionMap))
      return (pMap.get(key) & 64) === 64
    }
  }
}
</script>



// WEBPACK FOOTER //
// CheckPermission.vue?2fed4bd0